import { displayDateText } from "@util/moment";

export const adaptDeviceOrderChange = (raw = {}) => {
	const {
		applyDate,
		effectDate,
		employeeName,
		title,
		url,
	} = raw || {};



	return (
		{
			type: "deviceOrder",
			title: title,
			pdfUrl: url,

			// 卡片主內容說明區塊
			// descList: [],

			// Timeline 上方額外顯示的 meta
			timelineMetainfo: [
				{ label: "申請日期", text: displayDateText(applyDate) },
				{ label: "生效日期", text: displayDateText(effectDate) },
				{ label: "擔當", text: employeeName }
			]
		}
	);
};
